<script>
import { mapGetters } from 'vuex';
import MentionBox from '../mentions/MentionBox.vue';

export default {
  components: { MentionBox },
  props: {
    searchKey: {
      type: String,
      default: '',
    },
  },
  emits: ['replace'],
  computed: {
    ...mapGetters({
      cannedMessages: 'getCannedResponses',
    }),
    items() {
      const search = this.searchKey.toLowerCase();
      return this.cannedMessages
        .filter(msg => {
          if (!search) return true;
          return (
            msg.short_code.toLowerCase().includes(search) ||
            msg.content.toLowerCase().includes(search)
          );
        })
        .sort((a, b) => {
          if (!search) return 0;
          const aStartsWith = a.short_code.toLowerCase().startsWith(search);
          const bStartsWith = b.short_code.toLowerCase().startsWith(search);
          if (aStartsWith && !bStartsWith) return -1;
          if (!aStartsWith && bStartsWith) return 1;
          return 0;
        })
        .map(msg => ({
          label: msg.short_code,
          key: msg.short_code,
          description: msg.content,
        }));
    },
  },
  mounted() {
    this.$store.dispatch('getCannedResponse', {});
  },
  methods: {
    handleMentionClick(item = {}) {
      this.$emit('replace', item.description);
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <MentionBox
    v-if="items.length"
    :items="items"
    @mention-select="handleMentionClick"
  />
</template>
